export default ({ value, numberOfElectricalFeedsStart, numberOfElectricalFeedsMiddle, numberOfElectricalFeedsEnd, numberOfElectricalFeedsPerLine }) => {
    let pass  = false;
    pass = (Number(numberOfElectricalFeedsStart) + Number(numberOfElectricalFeedsMiddle) + Number(numberOfElectricalFeedsEnd)) >= Number(numberOfElectricalFeedsPerLine);
    return pass;
}
